import React from "react";
import { NavLink, Route, Routes, Navigate } from "react-router-dom";
import { BarChart3, LineChart as LineChartIcon } from "lucide-react";
import { ReportsOverview } from "./reports/Overview";
import { ReportsSummary } from "./reports/Summary";

const TABS = [
    { to: "", end: true, id: "overview", label: "Overview", icon: BarChart3 },
    { to: "summary", id: "summary", label: "Range summary", icon: LineChartIcon },
];

export function StaffReports() {
    return (
        <div className="space-y-6" data-testid="staff-reports">
            <header className="space-y-2">
                <div className="text-[10px] uppercase tracking-[0.28em] text-gold">Reports</div>
                <h1 className="font-serif font-light text-4xl text-navy">Business intelligence</h1>
                <p className="text-sm text-navy/60 max-w-2xl">
                    View business performance, revenue and downloadable reports.
                </p>
            </header>
            <nav className="flex flex-wrap gap-2 border-b border-navy/10 pb-2" data-testid="reports-subnav">
                {TABS.map((t) => (
                    <NavLink key={t.id} to={t.to} end={t.end} data-testid={`reports-tab-${t.id}`}
                        className={({ isActive }) =>
                            `inline-flex items-center gap-2 px-4 h-9 rounded-full text-xs uppercase tracking-[0.18em] border transition-colors ${
                                isActive
                                    ? "bg-gold/15 border-gold/50 text-gold"
                                    : "border-navy/15 text-navy/70 hover:text-navy hover:border-navy/40 bg-white"
                            }`}>
                        <t.icon className="h-3.5 w-3.5" strokeWidth={1.5} /> {t.label}
                    </NavLink>
                ))}
            </nav>
            <Routes>
                <Route index element={<ReportsOverview />} />
                <Route path="summary" element={<ReportsSummary />} />
                <Route path="*" element={<Navigate to="." replace />} />
            </Routes>
        </div>
    );
}
